import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b810f92"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "response-text" }
const _hoisted_3 = {
  key: 1,
  class: "container"
}
const _hoisted_4 = { class: "response-text" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "container"
}
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = { class: "label" }
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "klarna-payments-container" }, null, -1))
const _hoisted_26 = { class: "more-info-text" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "warning-text"
}
const _hoisted_29 = {
  key: 1,
  class: "loader-wrapper"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-ring" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_message = _resolveComponent("v-message")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_ctx.activationSuccessful)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('Subscription.SuccessfulActivation')), 1)
      ]))
    : (_ctx.activationFailed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('Subscription.FailedActivation')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_form, { id: "subscriptionForm" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("Common.ActivationCode")), 1),
                      _createVNode(_component_v_field, {
                        name: "activationCode",
                        type: "text",
                        class: "input form-control",
                        modelValue: _ctx.subscriptionModel.activationCode,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subscriptionModel.activationCode) = $event)),
                        label: _ctx.$t('Common.ActivationCode'),
                        readonly: "",
                        validateOnInput: true
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_v_message, { name: "activationCode" })
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("Common.Name")), 1),
                      _createVNode(_component_v_field, {
                        name: "name",
                        type: "text",
                        class: "input form-control",
                        modelValue: _ctx.subscriptionModel.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.subscriptionModel.name) = $event)),
                        rules: "required",
                        validateOnInput: true,
                        label: _ctx.$t('Common.Name')
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_v_message, { name: "name" })
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("Common.LastName")), 1),
                      _createVNode(_component_v_field, {
                        name: "lastName",
                        type: "text",
                        class: "input form-control",
                        modelValue: _ctx.subscriptionModel.lastName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.subscriptionModel.lastName) = $event)),
                        validateOnInput: true,
                        rules: "required",
                        label: _ctx.$t('Common.LastName')
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_v_message, { name: "lastName" })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("Common.EmailAddress")), 1),
                      _createVNode(_component_v_field, {
                        name: "email",
                        id: "email",
                        type: "email",
                        class: "input form-control",
                        modelValue: _ctx.subscriptionModel.email,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.subscriptionModel.email) = $event)),
                        validateOnInput: true,
                        rules: "required|email",
                        label: _ctx.$t('Common.EmailAddress')
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_v_message, { name: "email" })
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("Common.Address1")), 1),
                      _createVNode(_component_v_field, {
                        name: "line1",
                        type: "text",
                        class: "input form-control",
                        modelValue: _ctx.subscriptionModel.line1,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.subscriptionModel.line1) = $event)),
                        rules: "required",
                        label: _ctx.$t('Common.Address1'),
                        validateOnInput: true
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_v_message, { name: "line1" })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("Common.ZipCode")), 1),
                      _createVNode(_component_v_field, {
                        name: "zip",
                        type: "text",
                        class: "input form-control",
                        modelValue: _ctx.subscriptionModel.zip,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.subscriptionModel.zip) = $event)),
                        rules: "required",
                        label: _ctx.$t('Common.ZipCode'),
                        validateOnInput: true
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_v_message, { name: "zip" })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("Common.City")), 1),
                      _createVNode(_component_v_field, {
                        name: "city",
                        type: "text",
                        class: "input form-control",
                        modelValue: _ctx.subscriptionModel.city,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.subscriptionModel.city) = $event)),
                        rules: "required",
                        label: _ctx.$t('Common.City'),
                        validateOnInput: true
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_v_message, { name: "city" })
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("Common.MobilePhone")), 1),
                      _createVNode(_component_v_field, {
                        name: "mobilePhone",
                        type: "number",
                        class: "input form-control",
                        modelValue: _ctx.subscriptionModel.mobilePhone,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.subscriptionModel.mobilePhone) = $event)),
                        rules: _ctx.validatePhone,
                        label: _ctx.$t('Common.MobilePhone'),
                        validateOnInput: true
                      }, null, 8, ["modelValue", "rules", "label"]),
                      _createVNode(_component_v_message, { name: "mobilePhone" })
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("Common.SSN")), 1),
                      _createVNode(_component_v_field, {
                        name: "ssn",
                        type: "text",
                        class: "input form-control",
                        modelValue: _ctx.subscriptionModel.ssn,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.subscriptionModel.ssn) = $event)),
                        rules: _ctx.validateSSN,
                        maxlength: "13",
                        label: _ctx.$t('Common.SSN'),
                        placeholder: "yymmdd-xxxx",
                        validateOnInput: true
                      }, null, 8, ["modelValue", "rules", "label"]),
                      _createVNode(_component_v_message, { name: "ssn" })
                    ])
                  ]),
                  _: 1
                }),
                _hoisted_25,
                _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('Subscription.MoreInfo')), 1),
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.authorizeInKlarna && _ctx.authorizeInKlarna(...args))),
                  class: "button--base button--primary",
                  disabled: !_ctx.isFormValid ||
        !_ctx.validatePhone(_ctx.subscriptionModel.mobilePhone) ||
        !_ctx.validateSSN(_ctx.subscriptionModel.ssn)
                }, _toDisplayString(_ctx.$t('Subscription.Start')), 9, _hoisted_27),
                (!_ctx.isFormValid ||
        !_ctx.validatePhone(_ctx.subscriptionModel.mobilePhone) ||
        !_ctx.validateSSN(_ctx.subscriptionModel.ssn))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.$t('Subscription.FillAllFields')), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
        ]))
}